import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ROUTES} from 'src/app/route/routes';
import {CookieStoragerService} from 'src/app/services/cookie-storager.service';
import {UserService} from 'src/app/services/user.service';
import {environment} from 'src/environments/environment';
import {MatDialog} from "@angular/material/dialog";
import {Ship} from "../../../model";
import {ShipSelectionDialogComponent} from "../reservation-dialog/ship-selection-dialog.component";
import {SpinnerService} from "../../../_components/spinner/spinner.service";
import {ModalErrorComponent} from "../../../modal/modal-gestioneErrori/modal-error/modal-error.component";
import {MyErrorHandler} from "../../../constants/error";
import {ReservationService} from "../../../services/reservation.service";

@Component({
  selector: 'app-reservation-landing',
  templateUrl: './reservation-landing.component.html',
  styleUrls: ['./reservation-landing.component.scss'],
  standalone: false
})
export class ReservationLandingComponent implements OnInit {

  massReservation!: boolean;
  viewReservation!: boolean;
  anotherReservation!: boolean;
  availableShips: Array<Ship> = [];
  selectedShip: Ship | null = null;

  constructor(
    private router: Router,
    private userService: UserService,
    private reservationService: ReservationService,
    private cStorager: CookieStoragerService,
    private dialog: MatDialog,
    private spinner: SpinnerService,
  ) { }

  ngOnInit(): void {
    this.availableShips = this.userService.ships;
    if (this.availableShips.length === 1) {
      this.selectedShip = this.availableShips[0];
    }

    let storageRoles = this.userService.getCurrentUserRoles();
    if (storageRoles) {
      //this.roles = storageRoles;
      this.getRole();
    }
  }

  private getRole() {
    this.anotherReservation = true;
    this.massReservation = true;
    this.viewReservation = true;
  }

  private showError(err: any) {
    const dialogRef = this.dialog.open(ModalErrorComponent, {
      data: MyErrorHandler.getText(err),
    });

    dialogRef.afterClosed().subscribe((_) => {
      this.goTo('landing');
    });
  }

  openShipSelectionDialog(): void {
    const dialogRef = this.dialog.open(ShipSelectionDialogComponent, {
      width: '400px',
      data: { ships: this.availableShips }
    });

    // In your ReservationLandingComponent...
    dialogRef.afterClosed().subscribe(selectedId => { // 'result' is the ship ID
      console.log('The dialog was closed. Selected Ship ID:', selectedId);

      if (selectedId) {
        // Find the full ship object from the ID that was returned
        const selectedShipObject = this.availableShips.find(ship => ship.id_ship === selectedId);
        if (selectedShipObject) {
          this.selectedShip = selectedShipObject;
          this.goTo("mass"); // Now you can proceed
        }
      }
    });
  }

  goTo(path: string) {
    switch (path) {
      case 'home':
        this.router.navigate([ROUTES.HOME.path]);
        break;
      case 'report':
        this.router.navigate([ROUTES.RESERVATION_REPORT.path]);
        break;
      case 'mass':
        this.spinner.show();
        let currentUser = this.userService.getCurrentUser();
        if(this.selectedShip){
          this.reservationService.massiveReservation(this.selectedShip.id_ship).subscribe({
            error: (err) => {
              this.showError(err);
              this.spinner.hide();
            },
            complete: () => {
              this.spinner.hide();
              currentUser!.displayNameImp = "Massiva";
              this.cStorager.setElement('cu', currentUser, undefined, undefined, "/", environment.domain);
              window.open(
                environment.portaleFrontendUrl,
                'winMass'
              );
              this.router.navigate([ROUTES.HOME.path]);
            }
          })
        }
        break;
      case 'another':
        this.router.navigate([ROUTES.RESERVATION_ANOTHER.path]);
        break;
    }
  }

}
